import localeMessageBox from '@/components/message-box/locale/zh-CN';
import localeLogin from '@/views/login/locale/zh-CN';

import localeWorkplace from '@/views/dashboard/workplace/locale/zh-CN';

import localeMonitor from '@/views/dashboard/monitor/locale/zh-CN';

import localeSearchTable from '@/views/list/search-table/locale/zh-CN';
import localeCardList from '@/views/list/card/locale/zh-CN';

import localeStepForm from '@/views/form/step/locale/zh-CN';
import localeGroupForm from '@/views/form/group/locale/zh-CN';

import localeBasicProfile from '@/views/profile/basic/locale/zh-CN';

import localeDataAnalysis from '@/views/visualization/data-analysis/locale/zh-CN';
import localeMultiDAnalysis from '@/views/visualization/multi-dimension-data-analysis/locale/zh-CN';

import localeSuccess from '@/views/result/success/locale/zh-CN';
import localeError from '@/views/result/error/locale/zh-CN';

import locale403 from '@/views/exception/403/locale/zh-CN';
import locale404 from '@/views/exception/404/locale/zh-CN';
import locale500 from '@/views/exception/500/locale/zh-CN';

import localeUserInfo from '@/views/user/info/locale/zh-CN';
import localeUserSetting from '@/views/user/setting/locale/zh-CN';

import localeSettings from './zh-CN/settings';

export default {
  'menu.dashboard': '仪表盘',
  'menu.server.dashboard': '仪表盘-服务端',
  'menu.server.workplace': '工作台-服务端',
  'menu.server.monitor': '实时监控-服务端',
  'menu.list': '列表页',
  'menu.result': '结果页',
  'menu.exception': '异常页',
  'menu.form': '表单页',
  'menu.profile': '详情页',
  'menu.visualization': '数据可视化',
  'menu.user': '个人中心',
  'menu.arcoWebsite': 'Arco Design',
  'menu.faq': '常见问题',
  'navbar.docs': '文档中心',
  'navbar.action.locale': '切换为中文',
  // 新添加的
  'menu.order': '订单管理', // 订单管理
  'menu.customer': '客户管理',
  'menu.account': '账户管理', // 订单管理
  'menu.system': '系统设置', // 系统管理
  'menu.userManage': '管理员列表',
  'menu.appManage': 'APP版本',
  'menu.operation': '商户管理', // 用户运营
  'menu.customerManage': '客户列表',
  'menu.accountManage': '账户列表',
  'menu.merchantManage': '入驻申请',
  'menu.merchantList': '商户列表',
  'menu.accountChangeRecord': '变更记录',
  'menu.transaction': '商品管理', // 交易管理
  'menu.productManage': '商品列表',
  'menu.saleOrderManage': '销售订单',
  'menu.purchaseOrderManage': '调货订单',
  'menu.categoryManage': '类目管理',
  'menu.promotion': '推广管理', // 推广管理
  'menu.personManage': '推广人列表',
  'menu.incomeManage': '收益明细',
  'menu.settlementManage': '结算记录',
  'menu.subordinateManage': '下级用户管理',
  'menu.serveiceManage': '平台管理',
  'menu.modelManage': '弹框提醒管理',
  'menu.rechargeManage': '充值积分管理',
  ...localeSettings,
  ...localeMessageBox,
  ...localeLogin,
  ...localeWorkplace,

  ...localeMonitor,
  ...localeSearchTable,
  ...localeCardList,
  ...localeStepForm,
  ...localeGroupForm,
  ...localeBasicProfile,
  ...localeDataAnalysis,
  ...localeMultiDAnalysis,
  ...localeSuccess,
  ...localeError,
  ...locale403,
  ...locale404,
  ...locale500,
  ...localeUserInfo,
  ...localeUserSetting,
};
